<template>
    <b-form-group :invalid-feedback="error" :state="state">
        <channex-card-capture
            v-on="listeners"
            v-bind="attrs"
            :state="state"
            ref="capture"
            :valid-payment-card-types="validPaymentCardTypes"
            @validate-callback="handleValidateCallback"
        />
    </b-form-group>
</template>

<script>
    import { convertFromStripeCardType, PAYMENT_CARD_MAPPING } from '../../../constants';
    import ChannexCardCapture from '../channex-card-capture/channex-card-capture.vue';

    export default {
        name: 'FormChannexCardCapture',
        components: {
            ChannexCardCapture,
        },
        props: {
            value: {
                type: String,
            },
            error: {
                type: String,
                default: null,
            },
            validPaymentCardTypes: {
                type: Array,
                default: null,
            },
        },
        computed: {
            state() {
                if (this.error) {
                    return !this.error;
                }
            },
            attrs() {
                const { state, ...attrs } = this.$attrs;
                return attrs;
            },
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },
        },
        methods: {
            handleValidateCallback(value) {
                this.$emit('input', value);
            },
        },
    };
</script>
